import { BasicPerson, Person } from './Person'

export const generateFullName = (
    firstName: string,
    lastName: string,
    affix?: string,
): string => [firstName, affix, lastName].filter((part) => part != null && part !== '').join(' ')

export const getPersonFullName = (person: BasicPerson | Person): string => generateFullName(person.firstname, person.lastname, person.affix)
